/* eslint-disable import/prefer-default-export */
export const globalKey = Symbol('Global');
